module.exports = __webpack_public_path__ + "static/plumber-making-882abcdb04bf96e8c74d4e34bdd329f7.png";